export class StatisticTopInvoiceVehicleDto {

  public vehicleId!: string; // UUID
  public contactId!: string; // UUID
  public vehicleFullName!: string;
  public currencyCode!: string; // Enum: AccCurrency
  public invoiceCount!: number;
  public sumTotalNetAmount!: number;
  public minTotalNetAmount!: number;
  public maxTotalNetAmount!: number;
  public avgTotalNetAmount!: number;
  public discountCount!: number;
  public discountSumNetAmount: number | undefined;
  public discountMinNetAmount: number | undefined;
  public discountMaxNetAmount: number | undefined;
  public discountAvgNetAmount: number | undefined;

  constructor(init?: Partial<StatisticTopInvoiceVehicleDto> | undefined) {
    Object.assign(this, init);
  }
}
